import { useCallback } from 'react';
import { useSelectableOptions } from './useSelectableOptions';
import { toParentPath } from '../helpers/History';
export function useCollaboratorForm(collaborator, store, collaborator_id) {
    var _a;
    var _b = useSelectableOptions(((_a = collaborator === null || collaborator === void 0 ? void 0 : collaborator.services) === null || _a === void 0 ? void 0 : _a.map(String)) || []), selectedStretches = _b.selected, handleChange = _b.handleChange, hasChanged = _b.hasChanged;
    var handleCancel = useCallback(function () {
        toParentPath();
    }, []);
    var handleApplyCommission = useCallback(function () {
        if (!(collaborator === null || collaborator === void 0 ? void 0 : collaborator.id))
            return;
        if (confirm('¿Aplicar comisión?')) {
            store.collaboratorStore.applyCommission(collaborator.id)
                .then(function () {
                store.UI.newWarning('appliedCorrectly');
            })
                .catch(function () {
                store.UI.newError('appliedError');
            });
        }
    }, [collaborator, store]);
    var handleSubmit = useCallback(function () {
        if (!collaborator) {
            return function () { };
        }
        if (!hasChanged()) {
            if (!collaborator) {
                return;
            }
            return store.UI.newWarning('nada ha cambiado');
        }
        return store.collaboratorStore.update(collaborator_id, {
            services: selectedStretches,
            packets: [],
        }).then(function () {
            window.history.back();
        });
    }, [hasChanged, selectedStretches, collaborator_id, store]);
    return {
        selectedStretches: selectedStretches,
        handleChange: handleChange,
        handleCancel: handleCancel,
        handleApplyCommission: handleApplyCommission,
        handleSubmit: handleSubmit,
        hasChanges: hasChanged
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/hooks/useCollaboratorForm.ts
// module id = 595
// module chunks = 0